<template>
  <div>
    <div
      v-if="awardMeta.isCommentAward && comment"
      class="comment text-small-1 text-truncate"
      :title="comment"
      v-no-capture
    >
      {{ contextActorName }}: {{ comment }}
    </div>
    <checkin-values :checkin="checkin" :kr="krSnapshot" v-if="awardMeta.isCheckinAward" />
    <initiative-status-label
      :status="initiativeChangedStatus"
      v-if="awardMeta.isInitiativeStatusChangeAward"
    />
    <award-meta
      class="mt-3"
      :award="award"
      :org-id="context.organizationId"
      :show-note-as="showNoteAs"
      :clamp-note="clampNote"
      :prevent-image-viewer="preventImageViewer"
    />
  </div>
</template>

<script>
import convertHTMLToPlainText from '@/utils/convertHTMLToPlainText'
import getAwardMeta from '@/utils/getAwardMeta'
import * as R from 'ramda'
import CheckinValues from '@/components/CheckinValues'
import AwardMeta from '@/components/award/AwardMeta'
import InitiativeStatusLabel from '@/components/InitiativeStatusLabel'

/**
 * This is the component for rendering the award's informations. It includes below items:
 * - comment - rendered only when an award is given on comment
 * - checkin values  - rendered only when an award is given on checkin
 * - initiative status label - rendered only when an award is given on initiative status change
 * - award meta (badge, caption, note) - rendered for all awards
 */
export default {
  name: 'AwardWidget',
  props: {
    award: Object,
    showNoteAs: {
      type: String,
      default: 'html'
    },
    clampNote: {
      type: Boolean,
      default: false
    },
    preventImageViewer: Boolean
  },
  components: {
    CheckinValues,
    AwardMeta,
    InitiativeStatusLabel
  },
  data() {
    return {
      awardMeta: getAwardMeta(this.award)
    }
  },
  computed: {
    context() {
      return R.prop('context', this.award)
    },
    checkin() {
      return this.context.checkin
    },
    krSnapshot() {
      return this.context.keyResultSnapshot
    },
    comment() {
      const comment = this.context.comment
      return comment ? convertHTMLToPlainText(comment) : ''
    },
    contextActorName() {
      let actor = this.context.actor
      if (actor) {
        return actor.firstName
      }
      const actorId = this.context.actorId
      actor = this.$store.getters.userById(actorId)
      return actor?.firstName
    },
    initiativeChangedStatus() {
      return R.path(['changes', 'new'], this.context)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .kr-value {
  font-size: 0.8125rem;
}

/deep/ .status-label {
  font-size: 0.8125rem;
}
</style>
